export default __webpack_public_path__ + "static/media/logo-driver.b68ca705.png";